// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 0V2H15V0H17V2H21V19H6V2H10V0H12ZM11 15H16V13H11V15Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M4 6V21H15V23H2V6H4Z"}}]};

const TaskDoubleFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'task-double-filled',
    ref,
    icon: element,
  },
));

TaskDoubleFilledIcon.displayName = 'TaskDoubleFilledIcon';

export default TaskDoubleFilledIcon;
